import { type MouseEvent } from 'react';
import classnames from 'classnames';
import { useUser } from 'libs';

interface ToggleOption {
  key?: number | string;
  value?: string;
}

interface ToggleProps {
  disabled?: boolean;
  disabledOption?: string | null;
  isPro?: boolean;
  onChange: (filter: string) => void;
  options: ToggleOption[];
  testId?: string;
  value: (string | number)[] | boolean | number | string;
  variant?: 'default' | 'vertical';
}

const Toggle = ({
  disabled = false,
  disabledOption = null,
  isPro = false,
  onChange,
  options,
  testId,
  variant = 'default',
  value,
}: ToggleProps) => {
  const user = useUser();
  const disableAll = disabled || (isPro && !user.features.is_pro);

  const handleChange = (event: MouseEvent<HTMLButtonElement>) => {
    const filter = (event.target as HTMLElement).getAttribute('data-value');
    onChange(filter as string);
  };

  const isSelected = (key: number | string | undefined) => {
    if (Array.isArray(value)) {
      return value.indexOf(key as any) > -1;
    }

    return key === value;
  };

  return (
    <div
      className={classnames(variant === 'vertical' ? 'btn-group-vertical' : 'btn-group', 'w-100')}
      role="group"
      data-testid={testId}
    >
      {options.map((option) => {
        const className = isSelected(option.key) ? 'btn-toggle' : 'btn-light';

        return (
          <button
            key={option.key}
            data-testid={testId ? `${testId}-${option.key}` : null}
            data-value={option.key}
            type="button"
            onClick={handleChange}
            className={`btn ${className}`}
            disabled={disableAll || option.key === disabledOption}
          >
            {option.value}
          </button>
        );
      })}
    </div>
  );
};

export default Toggle;
